// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import 'vant/lib/index.css';
// import ElementUI from 'element-ui';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import  'babel-polyfill'
import SlideVerify from 'vue-monoplasty-slide-verify';
import ajax from './assets/js/ajax'
import uploadAxios from './assets/js/uploadAxios'
import pubMethod from './tools/public'

import 'babel-polyfill'
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()
import $ from 'jquery'
// import QRCode from 'qrcodejs2'
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
import crypto from 'crypto'
import Vant from 'vant';
import 'vant/lib/index.css';
import VConsole from 'vconsole'
// const  vConsole = new VConsole();
// export default vConsole
Vue.use(Vant);

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import '../src/assets/common.css'

Vue.use(ViewUI);
Vue.use(VueDirectiveImagePreviewer)
Vue.use(ajax)
Vue.use(uploadAxios)
Vue.use(SlideVerify);
Vue.use(VueAwesomeSwiper, /* { default global options } */)
// Vue.use(ElementUI);
// Vue.use(QRCode)

import store from './store/index'

Vue.config.productionTip = false
Vue.prototype.pubMethod = pubMethod;

/* eslint-disable no-new */

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {   //如果需要跳转 ，往下走（1）
    if (localStorage.getItem('uid')) {   //判断是否登录过，如果有登陆过，说明有token,或者token未过期，可以跳过登录（2）
      if (to.path === '/') { //判断下一个路由是否为要验证的路由（3）
        next('/');   // 如果是直接跳到首页，
      } else {    //如果该路由不需要验证，那么直接往后走
        next();
      }
    } else {
      console.log('没有');  //如果没有登陆过，或者token 过期， 那么跳转到登录页
      next('/');
    }
  } else {       //不需要跳转，直接往下走
    next();
  }
});

// 跳转后返回顶部
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js